import React from 'react';
import type { Theme } from '@mui/material';
import Popout from '../../../../component_library/components/Popout';
import type {
  ITheme,
  ThemeColor,
} from '../../../../component_library/styles/theme';
import { DataElementId } from '../../../../constants/data-element-tracking-ids';
import type { IPopoutData } from '../../../../dotcms/dotcms-models/dotcms-popout';
import HomepageModuleWrapper from '../homepage-module-wrapper/homepage-module-wrapper';
import { Page } from '../../../../app/page-url-path';
import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import HtmlBox from '../../../../component_library/components/HtmlBox';

interface IProps {
  theme: ITheme;
  muiTheme: Theme;
  prevBackgroundColor: ThemeColor;
  nextBackgroundColor: ThemeColor;
  data: IPopoutData;
}

const LearnMorePopout: React.FC<IProps> = ({
  theme,
  muiTheme,
  prevBackgroundColor,
  nextBackgroundColor,
  data,
}) => {
  const rootStyle = {
    paddingTop: '2px', // for Popout shadows
    paddingBottom: '8px', // for Popout shadows
    background: `linear-gradient(
      to bottom,
      ${prevBackgroundColor} 0%,
      ${prevBackgroundColor} 50%,
      ${nextBackgroundColor} 50%,
      ${nextBackgroundColor} 100%
    )`,
    [muiTheme.breakpoints.down('tablet')]: {
      paddingTop: '0',
    },
  };

  const { contentHtml, link } = data;
  const routeToCashlessPage = useGetRouteToIssuerPage(Page.ABOUT_CASHLESS);
  const linkUrl = link.url?.trim() ? link.url : routeToCashlessPage;

  return (
    <HomepageModuleWrapper dataComponentName="LearnMorePopout" sx={rootStyle}>
      <Popout
        dataElementId={DataElementId.HOMEPAGE_LINK_LEARN_MORE_POPOUT}
        theme={theme}
        muiTheme={muiTheme}
        link={{
          title: link?.text,
          to: linkUrl,
          dataElementId: DataElementId.HOMEPAGE_LINK_LEARN_MORE_CTA,
        }}
      >
        <HtmlBox html={contentHtml} />
      </Popout>
    </HomepageModuleWrapper>
  );
};

export default LearnMorePopout;
